<div class="full-width-image-container">
    <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>

<div class="top">
    <div>Do The <span>Right Thing</span></div>
    <div>On Point <span>With Safety</span></div>
    <div>Roll up <span>Your Sleeves</span></div>
</div>

<hr class="hr">
<br><br><br>
    
<div class="page-title">
    <h1 class="title-text">IT Forms</h1>
</div>

<div class="button-group">
    <div class="button-container">
        <div class="button-title">Computer Request Form</div>
        <a mat-raised-button routerLink="/computer-request-form" routerLinkActive="active" color="primary">View Form</a>
    </div>
    <div class="button-container">
        <div class="button-title">View IT Forms</div>
        <a mat-raised-button routerLink="/it-form-hub" routerLinkActive="active" color="primary">View Forms</a>
        <br>
        <div class="button-note">(Authorized Users Only)</div>
    </div>
</div>